import React, { FC } from "react";

import { RuntimeConfigurationProvider } from "@natera/platform/lib/provider/runtimeConfiguration";
import {
  ConfigProvider,
  IdleWrapper,
  IntlProvider,
  NotificationProvider,
  ServiceProvider,
  TestResultProvider,
  UnifiedPatientPortalServerProvider,
  UppAuthProvider,
  UserProvider,
  PatientActionsProvider,
} from "@app/provider";
import AuthProviderWrapper from "@app/provider/authProviderWrapper";
import SecurityProviderWrapper from "@app/provider/securityProviderWrapper";
import config from "@etc/config.json";
import oktaConfig from "@etc/okta.json";
import recaptchaConfig from "@etc/recaptcha.json";
import maintenanceConfig from "@etc/maintenance.json";
import Routing from "./routing";
import Maintenance from "@app/pages/public/maintenance";
import { BillingAccessProvider } from "@app/postBill/provider/billingAccessContext";

const App: FC = () => {
  return (
    <IntlProvider>
      <RuntimeConfigurationProvider>
        <ConfigProvider
          config={{
            ...config,
            okta: oktaConfig,
            maintenance: maintenanceConfig,
            recaptcha: recaptchaConfig,
          }}
        >
          <Maintenance>
            <ServiceProvider>
              <NotificationProvider>
                <AuthProviderWrapper>
                  <SecurityProviderWrapper>
                    <UnifiedPatientPortalServerProvider>
                      <PatientActionsProvider>
                        <UppAuthProvider>
                          <UserProvider>
                            <IdleWrapper>
                              <TestResultProvider>
                                <BillingAccessProvider>
                                  <Routing />
                                </BillingAccessProvider>
                              </TestResultProvider>
                            </IdleWrapper>
                          </UserProvider>
                        </UppAuthProvider>
                      </PatientActionsProvider>
                    </UnifiedPatientPortalServerProvider>
                  </SecurityProviderWrapper>
                </AuthProviderWrapper>
              </NotificationProvider>
            </ServiceProvider>
          </Maintenance>
        </ConfigProvider>
      </RuntimeConfigurationProvider>
    </IntlProvider>
  );
};

export default App;
